import { render, staticRenderFns } from "./timDec.vue?vue&type=template&id=e74c8dfc&scoped=true"
import script from "./timDec.vue?vue&type=script&lang=js"
export * from "./timDec.vue?vue&type=script&lang=js"
import style0 from "./timDec.vue?vue&type=style&index=0&id=e74c8dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74c8dfc",
  null
  
)

export default component.exports